import { JwtToken, UserRolesIds } from './jwt';
import { ADMINISTRATOR_ROLE_ID } from './constants';

type AuthContext = { jwtToken?: JwtToken } | null | undefined;

export function jwtToken(context: AuthContext): JwtToken | undefined {
  return context?.jwtToken;
}

export function userId(context: AuthContext): number {
  return jwtToken(context)?.userId ?? 0;
}

export function userName(context: AuthContext): string {
  return jwtToken(context)?.userName ?? 'uknown';
}

export function userIsAdmin(context: AuthContext): boolean {
  const jwt = jwtToken(context);
  const roles: UserRolesIds[] | undefined = jwt?.userRolesIds;
  const hasAdmin = roles?.filter((v) => v.userroleId === ADMINISTRATOR_ROLE_ID);
  return !!(hasAdmin && hasAdmin.length > 0);
}
